module.exports = __webpack_public_path__ + "img/page1bg.429a028f.png";